<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Banner Image</label>
          <div class="group-item">
            <div>
              <v-checkbox v-model="fields.bannerImage.useBannerMobile" label="Use banner mobile" hide-details />
              <div v-if="fields.bannerImage.useBannerMobile" class="mt-2">
                <UploadImage
                  @callback="handleUploadBannerMobile"
                  :image="{ imageSrc: fields.bannerImage.bannerMobile }"
                  :height="`160`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveBannerMobile"
                />
              </div>
            </div>
            <div class="mt-3">
              <label class="mb-2 d-block">Desktop Banner</label>
              <UploadImage
                @callback="handleUploadBannerDesktop"
                :image="{ imageSrc: fields.bannerImage.bannerDesktop }"
                :height="`160`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveBannerDesktop"
              />
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Content Wrapper</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model.number="fields.wrapContent.widthContent"
                  type="number"
                  label="Content width"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Title Banner</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.titleBanner.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center" style="gap: 10px">
              <label class="label-input mb-0">Key Benefits</label>
              <input type="checkbox" v-model="fields.keyBenefits.show" />
            </div>
            <v-btn small text color="primary" @click="handleAddBenefit">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Benefit</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion v-if="fields.keyBenefits.items && fields.keyBenefits.items.length">
              <v-expansion-panel v-for="(item, index) in fields.keyBenefits.items" :key="`benefit-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Benefit {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveBenefit(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="mb-2 d-block">Icon</label>
                    <UploadImage
                      @callback="obj => handleUploadBenefitIcon(obj, index)"
                      :image="{ imageSrc: item.icon || '' }"
                      :height="`120`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemoveBenefitIcon(index)"
                    />
                  </div>
                  <div>
                    <label class="mb-2 d-block">Text Content</label>
                    <ckeditor :editor="editor" v-model="item.text" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div v-else class="text-center py-4 text-muted">No benefits added</div>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center" style="gap: 10px">
            <label class="label-input mb-0">Call To Action Button</label>
            <input type="checkbox" v-model="fields.button.show" />
          </div>
          <div class="group-item" v-if="fields.button.show">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.text" label="Button Text" hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.href" label="Button Link" hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.button.bgButton"
                  default-color="#c75023"
                  label="Button Background Color"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.button.colorButton"
                  default-color="#ffffff"
                  label="Button Text Color"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="12">
                <div>
                  <v-checkbox v-model="fields.button.showDiscount" label="Show Discount" hide-details />
                </div>
                <div v-if="fields.button.showDiscount">
                  <v-text-field v-model="fields.button.valueDiscount" suffix="%" hide-details />
                </div>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="fields.button.showIcon" label="Button Icon" hide-details />
                <div v-if="fields.button.showIcon">
                  <UploadImage
                    @callback="handleUploadButtonIcon"
                    :image="{ imageSrc: fields.button.icon }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveButtonIcon"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import ColorPicker from './common/color-picker.vue';

export default {
  name: 'card-banner-sowhatbuy-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Card Banner Sowhatbuy Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        bannerImage: {
          useBannerMobile: true,
          bannerDesktop: '',
          bannerMobile: '',
        },
        wrapContent: {
          widthContent: 1000,
        },
        titleBanner: {
          content: '',
        },
        keyBenefits: {
          show: true,
          items: [],
        },
        button: {
          show: true,
          showDiscount: true,
          href: '',
          valueDiscount: '',
          text: 'Buy Now',
          showIcon: true,
          icon: '',
          bgButton: '#c75023',
          colorButton: '#ffffff',
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        bannerImage: { ...this.fields.bannerImage, ...(extract.bannerImage || {}) },
        wrapContent: { ...this.fields.wrapContent, ...(extract.wrapContent || {}) },
        titleBanner: { ...this.fields.titleBanner, ...(extract.titleBanner || {}) },
        keyBenefits: { ...this.fields.keyBenefits, ...(extract.keyBenefits || {}) },
        button: { ...this.fields.button, ...(extract.button || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardBannerSowhatbuy(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadBannerMobile(obj) {
      this.fields.bannerImage.bannerMobile = obj.imageSrc || '';
    },
    handleRemoveBannerMobile() {
      this.fields.bannerImage.bannerMobile = '';
    },
    handleUploadBannerDesktop(obj) {
      this.fields.bannerImage.bannerDesktop = obj.imageSrc || '';
    },
    handleRemoveBannerDesktop() {
      this.fields.bannerImage.bannerDesktop = '';
    },
    handleAddBenefit() {
      if (!this.fields.keyBenefits.items) {
        this.$set(this.fields.keyBenefits, 'items', []);
      }
      this.fields.keyBenefits.items.push({
        icon: '',
        text: '<p>New Benefit</p><p>Subtext</p>',
      });
    },
    handleRemoveBenefit(index) {
      this.fields.keyBenefits.items.splice(index, 1);
    },
    handleUploadBenefitIcon(obj, index) {
      if (!this.fields.keyBenefits.items[index]) return;
      this.$set(this.fields.keyBenefits.items[index], 'icon', obj.imageSrc || '');
    },
    handleRemoveBenefitIcon(index) {
      if (!this.fields.keyBenefits.items[index]) return;
      this.$set(this.fields.keyBenefits.items[index], 'icon', '');
    },
    handleUploadButtonIcon(obj) {
      this.fields.button.icon = obj.imageSrc || '';
    },
    handleRemoveButtonIcon() {
      this.fields.button.icon = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
